import React, {useEffect} from 'react';
import {Form,Navbar,Container,Nav,NavDropdown,Dropdown} from 'react-bootstrap';
import {activatedRegion} from '../../redux/userProfile/userAction';
import {useSelector, useDispatch} from 'react-redux';
import logo from '../../assets/logo.svg';
import userImage from '../../assets/Images/User.png';
import './Header.scss';


const resources = [
    {
        data: 'DataDog',
        routing: 'https://tmna-ctp.datadoghq.com/'
    },
    {
        data: 'AWS Console',
        routing: 'https://toyotaconnected.okta.com/'
        
    },
    {
        data: 'AWS Health Dashboard',
        routing: 'https://health.aws.amazon.com/health/status'
        
    },
    {
        data: 'MongoDB Console',
        routing: 'https://tmna-ctp.datadoghq.com/dashboard/w4j-5ks-n4u/mongodb-health-check-kavya?from_ts=1641935997219&to_ts=1641939597219&live=true'
    },
    {
        data: 'AIVEN Console',
        routing: 'https://tmna-ctp.datadoghq.com/dashboard/a7j-kbc-ubb/aiven-kafka-production-mr?from_ts=1641766940984&to_ts=1641939740984&live=true'
    },
    {
        data: 'Runbook',
        routing: 'https://toyotaconnected.atlassian.net/wiki/spaces/CT/pages/3035333377/Smart+Observability',
        levelOne: [
           {
               data: 'All Apps',
               routing: 'https://toyotaconnected.atlassian.net/wiki/spaces/CT/pages/3035333377/Smart+Observability'
           },
           {
                data: 'Navi',
                routing: 'https://toyotaconnected.atlassian.net/wiki/spaces/CT/pages/3035333377/Smart+Observability'
           },
           {
                data: 'IDP',
                routing: 'https://toyotaconnected.atlassian.net/wiki/spaces/CT/pages/3035333377/Smart+Observability'
            }
        ]
    },
    {
        data: 'FMEA',
        routing: 'https://toyotaconnected.atlassian.net/wiki/spaces/CT/pages/3035333377/Smart+Observability'
    },
];
// interface Iprops {
//     theme: string;
//     onThemeChanger(e:React.ChangeEvent<HTMLInputElement>): any;
    
// }
const Header = (props:any) => {

    const dispatch = useDispatch();
    const name = useSelector((state:any) => state.user.name)
    const env = useSelector((state:any)=> state.env.env)
    const activeRegion = useSelector((state:any) => state.region)
    console.log('active',name);

    const CustomToggle = React.forwardRef(({ children, onClick }:any, ref:any) => (
        <a
          href="/" ref={ref}
          onClick={(e) => {
            e.preventDefault();
            onClick(e);
          }}
        >
          {children}
          <span className="fa fa-sort-desc arrowDown"></span>
        </a>
      ));

    const navClick = (e:any,item:any) => {
        if(item.toLowerCase() === 'runbook') {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    const onRegionchange = (e:any) => {
       let value = e.target.value
        if(value.toLowerCase() === 'active-active'){
            dispatch(activatedRegion('active'))
        }
       else {
            dispatch(activatedRegion('canary'))
       }
    }

    return <>
    <div className='headerBlock clearBlock'>
      <Navbar variant="dark" bg="dark" expand="lg">
        <Container fluid>
            <img src={logo} alt='logo' className='logoImg'/>
            <Navbar.Brand href="/">Global Health Check Dashboard – 21 MM Services - {env}</Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarControl" />
            <Navbar.Collapse id="navbar-dark-example">
            <Nav>
                <a href='/' className='nav-link active'>Dashboard</a>
                <div className='separator'></div>
                <NavDropdown id="resource-dropdown" className='resourceDropdown' title="Resources" align='start'>
                    {
                        resources.map((item,index)=> {
                            
                            return <NavDropdown.Item key={index} href={item.routing} target={'_blank'} onClick={(e:any)=> {navClick(e,item.data)}}>
                                {!item.levelOne? item.data : <Dropdown>
                                    <Dropdown.Toggle id="dropdown-nested">
                                        {item.data}
                                    </Dropdown.Toggle>
                                
                                    <Dropdown.Menu className='nestedDropdownMenu'>
                                        {
                                            item.levelOne.map((item,index) => {
                                                return <Dropdown.Item target='_blank' href={item.routing} key={index} onClick={(e:any)=> {e.stopPropagation()}}
                                                >{item.data}</Dropdown.Item>
                                            })
                                        }
                                    </Dropdown.Menu>
                               </Dropdown>
                                }
                            </NavDropdown.Item>
                            
                        })
                    }
                </NavDropdown>
            </Nav>
             <div className='separator'></div>
             {/* <Form.Select aria-label='selectMenu' className='activeRegions' size='sm' onChange={onRegionchange}>
                <option value='Active-Active'>Active - Active</option>
                <option value='Canary'>Canary</option>
             </Form.Select>
            <div className='separator'></div>  */}
            <Form.Check 
                type="switch"
                id="themeToggle"
                label= {props.theme}
                className='mt-1 themeToggler'
                defaultChecked={true}
                onChange={(e:React.ChangeEvent<HTMLInputElement>):void=>{props.onThemeChanger(e)}}
            />
            <div className='separator'></div>
            <div className='dropdownMenu'>
                <Dropdown className='userDropdown' align='end'>
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                        <span className='userName'>{name? name : "User"}</span>
                        <img src={userImage} alt='userImage' className='userImage'/>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item eventKey="1" onClick={props.logout}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            </Navbar.Collapse>
        </Container>
     </Navbar>
    </div>
    </>
}

export default Header;